<template>
  <div class="step_inner">
    <h2>2.薪资信息</h2>
    <el-form ref="form" :model="formData"  :rules="rules" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="12">
          <!--工资单位1 天 2 小时 3 月 4 次 5 单-->
          <el-form-item label="工资单位" prop="unit">
            <el-select
              v-model="formData.unit" placeholder="请选择"
                clearable
                filterable
                style="width:100%"
              >
              <el-option label="天" value="1"/>
              <el-option label="小时" value="2"/>
              <el-option label="月" value="3"/>
              <el-option label="次" value="4"/>
              <el-option label="单" value="5"/>
            </el-select>
          </el-form-item>

          <el-form-item label="综合工资" prop="wages_min">
            <el-col :span="11">
              <el-input v-model="formData.wages_min" placeholder="最低工资"></el-input>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-input v-model="formData.wages_max" placeholder="最高工资"></el-input>
            </el-col>
          </el-form-item>


          <!---'wages_way':'['360-104']',-->

          <el-form-item label="工资计算方式" prop="wages_way">
            <el-row  v-for="(item, index) in formData.wages_way" :key="index">
              <el-col :span="8">
                <el-input  placeholder="工资项（如全勤）" v-model="item.name"></el-input>
              </el-col>
              <el-col class="line" :span="1">-</el-col>
              <el-col :span="8">
                <el-input  placeholder="金额" v-model="item.value"></el-input>
              </el-col>
              <el-col :span="7">
                <div v-if="index>0" @click="delwages_way(index)" style="display: flex;justify-content: flex-start;align-self: center;align-items:center">
                  <img src="@/assets/image/del_wages_way.png" style="width:20px;height: 20px;"></img>
                  <span>删除方式</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="11">
                <el-button @click="addwages_way">添加计算方式</el-button>
              </el-col>
            </el-row>  

          </el-form-item>

          <!--1:日结，2:月结，3:周结，:4完工结-->
          <el-form-item label="结算周期" prop="method">
            <el-select v-model="formData.method" placeholder="请选择">
              <el-option label="日结" value="1"></el-option>
              <el-option label="月结" value="2"></el-option>
              <el-option label="周结" value="3"></el-option>
              <el-option label="完工结" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工作标签" prop="benefits">
           
            <el-tag
              :key="tag"
              v-for="tag in formData.benefits"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
          </el-form-item>


          <el-form-item label="工作时间" prop="work_start_time">
            <el-row>
              <el-col :span="11">
                <el-input  placeholder="开始时间" v-model="formData.work_start_time"></el-input>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-input  placeholder="结束时间" v-model="formData.work_end_time"></el-input>
              </el-col>
            </el-row>

          </el-form-item>




          <el-form-item label="联系人" prop="contact">
            <el-input placeholder="请输入联系人" v-model="formData.contact"></el-input>
          </el-form-item>


          <el-form-item label="联系电话" prop="phone">
            <el-input placeholder="请输入联系电话" v-model="formData.phone" maxlength="11"></el-input>
          </el-form-item>


         

        </el-col>

        <el-col :span="12">
          

        </el-col>

      </el-row>
      <div style="text-align:center">
        <el-button  @click="handleLastStep">上一步</el-button>
        <el-button type="primary" @click="handleNextStep">提交</el-button>
      </div>

      

    </el-form>
  </div>
</template>

<script>

import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";
import ImageUpload from '@/components/ImageUpload';

export default {
  components: {
    ImageUpload
  },

  data () {
    return {
   
      formData:  {
          
          unit:"1",//工资单位1 天 2 小时 3 月 4 次 5 单
          wages_min:'',//最低薪资
          wages_max:'',//最高薪资
          wages_way:[
            {name:'',value:'',}
          ],//工资计算方式
          method:null,//1:日结，2:月结，3:周结，:4完工结
          benefits:[],//工作福利标签
          work_start_time:'9:00',//每日工作开始时间
          work_end_time:'18:00',//每日工作结束时间
          contact:'',//联系人
          phone:'',//联系电话
      },
      rules: {
        unit: [
          { required: true, message: '请选择工资单位', trigger: 'blur' }
        ],
        wages_max: [
          { required: true, message: '请输入最高薪资', trigger: 'blur' }
        ],

        wages_min: [
          { required: true, message: '请输入最低薪资', trigger: 'blur' }
        ],


        wages_way: [
          { required: true, message: '请输入工资计算方式', trigger: 'blur' }
        ],

        method: [
          { required: true, message: '请输入结算方式', trigger: 'blur' }
        ],

        benefits: [
          { required: true, message: '请输入标签', trigger: 'blur' }
        ],

        work_start_time: [
          { required: true, message: '请输入每日工作开始时间', trigger: 'blur' }
        ],

        work_end_time: [
          { required: true, message: '请输入每日工作结束时间', trigger: 'blur' }
        ],

        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
      },
        inputVisible: false,
        inputValue: '',

    }
  },

  created(){

  },

  mounted () {
  },
  methods:{
  
    setParams(obj){
      this.formData=obj;
      this.formData.method=this.formData.method+''
      this.formData.unit=this.formData.unit+''

     /* var newwages_way=[];
      for (let item of this.formData.wages_way) {
         var arr=item.split("-");
         newwages_way.push({wages_way1:arr[0],wages_way2:arr[1],})
      }
      this.formData.wages_way=newwages_way;*/
    },
    // 点击上一步
    handleLastStep() {
      this.$emit('handleLastStep')
    },
    
    // 点击下一步
    handleNextStep() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit('handleNextStep',this.formData);
        }

      });
    },

    addwages_way(){
      this.formData.wages_way.push({name:'',value:'',})
  
    },

    delwages_way(index){
      this.formData.wages_way.splice(index, 1)

    },
    handleClose(tag) {
        this.formData.benefits.splice(this.formData.benefits.indexOf(tag), 1);
      },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.formData.benefits.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }
}
</script>


<style lang="scss" scoped>
.step_inner {
  h2 {
    margin: 0;
    font-size: 19px;
    line-height: 50px;
  }
  .el-col {
    min-height: 51px;
  }
}


.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .line{
    text-align: center;
  }
</style>